var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterOpenEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1226 5.16284V5.13989L8.97979 0.960327C8.71634 0.781587 8.37881 0.691406 8.04129 0.691406C7.70377 0.691406 7.36572 0.781046 7.10279 0.960327L0.902247 5.17918C0.380825 5.34047 0 5.83575 0 6.41983V14.1958C0 14.9102 0.569768 15.4918 1.26968 15.4918H14.8129C15.5128 15.4918 16.0826 14.9102 16.0826 14.1958V6.41983C16.0826 5.8144 15.6734 5.30437 15.1226 5.16284ZM2.50852 5.12383H13.573L8.51001 1.67853C8.26454 1.51167 7.81698 1.51167 7.57151 1.67853L2.50852 5.12383ZM14.8864 5.99485C14.8621 5.99053 14.8383 5.98783 14.8129 5.98783H1.27074C1.24534 5.98783 1.22101 5.99053 1.1972 5.99485L7.57257 10.3332C7.81804 10.5001 8.2656 10.5001 8.51107 10.3332L14.8864 5.99485ZM0.846452 14.1958C0.846452 14.4345 1.03585 14.6278 1.26968 14.6278H14.8129C15.0467 14.6278 15.2361 14.4345 15.2361 14.1958V6.79459L8.97979 11.0514C8.71686 11.2307 8.37881 11.3203 8.04129 11.3203C7.70377 11.3203 7.36625 11.2301 7.10279 11.0514L0.846452 6.79459V14.1958Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterOpenEnvelope);
export default __webpack_public_path__ + "static/media/letter-open-envelope.11760e191c7b5522be919db029f89403.svg";
export { ForwardRef as ReactComponent };